<template>
  <Page>
    <Modal v-if="shouldActiveModal" :size="'larger'" :customClass="'allow-overflow'">
      <div class="modal-header scheduler-modal-header">
        <h5>แก้ไขหมวดหมู่{{ editingItem.title }}</h5>
        <button
          type="button"
          class="btn btn-link btm-sm btn-close-container"
          @click.stop="onCloseModal">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <form v-on:submit.prevent="onSaveEditItem">
        <div class="modal-body">
          <div class="row">
            <div class="col-md-8 col-12">
              <FormGroup :errorMessage="error.title">
                <h5 class="name">ชื่อหมวดหมู่</h5>
                <input
                  disabled
                  type="text"
                  placeholder="ชื่อหมวดหมู่"
                  class="form-control"
                  :class="{'is-invalid': error.title}"
                  v-model="editingItem.title"/>
                <div
                  class="invalid-feedback"
                  v-if="error.title">
                  {{error.title}}
                </div>
              </FormGroup>
              <FormGroup :errorMessage="error.description">
                <h5 class="name">คำอธิบายหมวดหมู่</h5>
                <input
                  type="text"
                  placeholder="คำอธิบายหมวดหมู่"
                  class="form-control"
                  :class="{'is-invalid': error.description}"
                  v-model="editingItem.description"/>
                <div
                  class="invalid-feedback"
                  v-if="error.description">
                  {{error.description}}
                </div>
              </FormGroup>
            </div>
            <div class="col-md-4 col-12">
              <FormGroup>
                <ImageField
                  :image.sync="editingItem.bigCoverImage"
                  aspectRatio="4:3"
                  imageViewSize="cover640w480h"
                  title="รูปปกหมวดหมู่ขนาดใหญ่"
                  hintText="ขนาดภาพที่เหมาะสม 640x480"
                  emptyMessageText="ไม่มีรูปปกขนาดใหญ่" />
              </FormGroup>
              <FormGroup>
                <ImageField
                  :image.sync="editingItem.smallCoverImage"
                  aspectRatio="1:1"
                  imageViewSize="cover640w640h"
                  title="รูปปกหมวดหมู่ขนาดเล็ก"
                  hintText="ขนาดภาพที่เหมาะสม 640x640"
                  emptyMessageText="ไม่มีรูปปกขนาดเล็ก" />
              </FormGroup>
            </div>
          </div>
        </div>
        <div class="modal-footer scheduler-modal-footer">
          <button type="submit" class="btn btn-primary">
            บันทึก
          </button>
        </div>
      </form>
    </Modal>
    <template v-slot:page-header>
      <div class="container">
        <div class="page-header">
          <div class="title-container">
            <div class="title">แก้ไข หมวดหมู่</div>
          </div>
          <div class="actions">
            <small class="text-danger mr-3" v-if="isServerError()">พบข้อผิดพลาดในการบันทึกข้อมูล
              กรุณาลองอีกครั้งหรือติดต่อผู้ดูแลระบบ code :
              {{ errorStatus }}</small>
            <small class="text-danger mr-3" v-if="isError422()">พบข้อผิดพลาดในการบันทึกข้อมูล กรุณาตรวจสอบข้อมูลที่กรอกอีกครั้ง</small>
            <small
              class="text-success font-weight-bold mr-3"
              v-if="saveProgramCategoryState.isSaved">
              <i class="fa fa-check" /> บันทึกแล้ว
            </small>
            <button
              type="submit"
              class="btn btn-primary"
              @click.stop="onSubmit()">
              บันทึก
            </button>
          </div>
        </div>
      </div>
    </template>
    <div class="container">
      <div class="section-container">
        <DisplayGrid @onEditItem="onEditItem" :items="items" :canDrag="true" />
      </div>
    </div>
  </Page>
</template>

<script>
import _ from 'lodash';
import Page from '@/layouts/Page.vue';
import Modal from '@/components/Modal.vue';
import FormGroup from '@/components/FormGroup.vue';
import ImageField from '@/image/ImageField.vue';

import {
  loadComponentById,
  updateComponentById,
} from '../api';
import DisplayGrid from './components/DisplayGrid.vue';

export default {
  components: {
    Page,
    DisplayGrid,
    Modal,
    FormGroup,
    ImageField,
  },
  data() {
    return {
      items: [],
      editingItem: null,
      errorStatus: null,
      error: {
        title: null,
        description: null,
      },
      saveProgramCategoryState: {
        isSaving: false,
        isSaved: false,
      },
    };
  },
  computed: {
    pageDesignerKey() {
      return this.$route.params.pageDesignerKey;
    },
    gridId() {
      return this.$route.params.gridId;
    },
    shouldActiveModal() {
      return !_.isEmpty(this.editingItem);
    },
  },
  created() {
    this.load();
  },
  methods: {
    isServerError() {
      return this.errorStatus && this.errorStatus !== 422;
    },
    isError422() {
      return this.errorStatus && this.errorStatus === 422;
    },
    async load() {
      const response = await loadComponentById(
        this.pageDesignerKey,
        this.gridId,
      );
      this.items = response.data.data.items;
    },
    async onSubmit() {
      const allItems = { allItems: this.items };
      const payload = {
        name: 'grid',
        data: allItems,
      };
      try {
        await updateComponentById(
          this.pageDesignerKey,
          this.gridId,
          payload,
        );
        this.saveProgramCategoryState.isSaved = true;
      } catch (error) {
        this.errorStatus = error.response.status;
        this.saveProgramCategoryState.isSaved = false;
      }
    },
    async onSaveEditItem() {
      const result = this.items.map((item) => (item.title === this.editingItem.title ? this.editingItem : item));
      if (result) {
        this.onCloseModal();
      }
    },
    onEditItem(item) {
      this.editingItem = item;
    },
    onCloseModal() {
      this.editingItem = null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/variables.scss";
@import "./src/assets/scss/themes/layouts/page.scss";
@import "./src/assets/scss/themes/components/section-container.scss";

.section-container {
  background: white;
  padding: $spacer / 2 $spacer;
  .section {
    box-shadow: 0 0 30px 0 rgba(82, 63, 105, 0.05);
    margin-bottom: $spacer * 1.5;
  }
}
</style>
